import type { SxProps, Theme } from '@mui/material/styles';

// Hosted Fields render inside Braintree iframes: they can't read our CSS
// variables or load web fonts, so styles must be resolved values.
const FONT_STACK =
  '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const themeColor = (name: string): string => {
  const channels = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return `rgb(${channels})`;
};

export const hostedFieldStyles = (): Record<string, Record<string, string>> => {
  const ink = themeColor('--ink');
  return {
    input: {
      'font-family': FONT_STACK,
      'font-size': '14px',
      'font-weight': '500',
      color: ink,
    },
    ':focus': { color: ink },
    '::placeholder': { color: themeColor('--muted'), 'font-weight': '400' },
    '.invalid': { color: ink },
  };
};

export const hostedFieldSx: SxProps<Theme> = {
  display: 'flex',
  height: 46,
  alignItems: 'center',
  borderRadius: 1.5,
  border: 1,
  borderColor: 'divider',
  bgcolor: 'background.default',
  px: 1.75,
  // A dark-scheme host behind a light-scheme iframe gets an opaque white backdrop.
  colorScheme: 'light',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&.braintree-hosted-fields-focused': {
    borderColor: 'text.primary',
    boxShadow: 'none',
  },
  '&.braintree-hosted-fields-invalid': {
    borderColor: 'primary.main',
  },
};
